<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">
            {{ t('Contract control activity modal title - (Contract control section) - Add/Edit activity', {
                action: tForm.id.value ? 'Edit' : 'Add'
            }) }}</h4>
        <button type="button" class="close" (click)="activeModal.close(null)" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="todoForm" (ngSubmit)="submitTodo()">
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <label for="Description">{{ t('Contract control activity modal field name - (Contract control section) - Description') }}</label>
            <fieldset class="form-label-group">
                <textarea class="form-control" id="label-textarea" rows="3" formControlName="description" [placeholder]="t('Contract control activity modal description field placeholder')" [ngClass]="{ 'is-invalid error': submitted && tForm.description.errors }"></textarea>
                <div *ngIf="submitted && tForm.description.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && tForm.description.errors }">
                    <div *ngIf="tForm.description.errors.required">{{ t('Field required (form validation) - Field name is required', {
                        fieldName: t('Contract control activity modal field name - (Contract control section) - Description')
                    }) }}</div>
                </div>
            </fieldset>
            <div class="form-group">
                <label for="first-name-icon">{{ t('Contract control activity modal field name - (Contract control section) - Due Date') }}</label>
                <div class="col-12 p-0">
                    <div class="input-group CC_datePicker">
                        <input type="text" mwlFlatpickr [value]="tForm.due_date?.value" class="form-control" (change)="dueDate($event)" [altInput]="true" [altFormat]="(false | userTimeZoneFormat) | async" [convertModelValue]="true" [ngClass]="{'is-invalid error' : submitted && tForm.due_date.errors }"/>
                    </div>
                </div>
            </div>
            <div class="addAsignIconCont">
                <label>{{ t('Contract control activity modal field text - (Contract control section) - Assign to') }}:</label>
                <p>
                    <span   (click)="collapse.toggle()"
                            [attr.aria-expanded]="!isCollapsed"
                            aria-controls="collapseExample">
                        <i class="addAsignIcon cursor-pointer" [data-feather]="'plus-circle'" [size]="35" ></i>
                    </span>
                </p>
      
                <div class="d-flex justify-content-start align-items-center">
                    <div class=" position-relative todoAvatar bg-transparent" [autoClose]="true" triggers="hover" [ngbTooltip]="selectedUser.name" placement="top" container="body" *ngFor="let selectedUser of tForm.users.value; let i = index;">
                        <span class="remove-user" (click)="removeSelectedUser(i)">
                            <i  data-feather="x-circle" [size]="12" class="todoAvatarDeleteIcon position-absolute text-danger cursor-pointer"></i>
                        </span>
                        <app-user-avatar
                                class="user-avatar"
                                [userId]="selectedUser?.userable?.id"
                                [shortcutName]="selectedUser?.userable?.name ?? '' | shortName">
                        </app-user-avatar>
                    </div>
                </div>
            </div>

            <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
                <div class="input-group input-group-merge p-0">
                    <ng-autocomplete class="form-control CC_autoCompleteSearch users-search px-1" #auto [data]="managersAndGroups | filterAssignedUsers: todoForm?.value?.users ?? []"
                                     (inputChanged)="searchManagers($event)" [searchKeyword]="keyword" [placeholder]="t('Search manager modal field placeholder - (Contract control section) - Search managers')"
                                     (selected)='selectEvent($event);auto.clear();collapse.toggle()' [itemTemplate]="itemTemplate"
                                     (inputCleared)="inputCleared($event)" [notFoundTemplate]="notFoundTemplate"
                                     [isLoading]="searchManagerLoading"></ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                        <span class="item d-flex flex-column p-1">
                            <span class="d-flex" [innerHTML]="item.name"></span>
                            <span class="mt-0">{{item.email}}</span>
                        </span>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                    </ng-template>
                </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="reset" class="btn btn-outline-secondary" (click)="activeModal.close(null)" rippleEffect>
                {{ t('Cancel button text (cancel button) - cancel') }}
            </button>
            <button type="submit" class="btn btn-primary" [disabled]="loading" rippleEffect>
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                {{ t('Contract control activity modal button text - (Contract control section) - Create/Update task', {
                    action: tForm.id.value ? 'Update' : 'Create'
                }) }}
            </button>
        </div>
    </form>
</ng-container>
